import React, { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import PropTypes from 'prop-types'
import { XIcon } from '@heroicons/react/outline'

const ServicingBranchModal = ({ servicingBranch, isOpen, setIsOpen }) => {
    const closeModal = () => {
        setIsOpen(false)
    }

    return (
        <>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog
                    as="div"
                    className="relative z-200"
                    onClose={closeModal}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-modalBackground" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center text-center md:px-0 px-4">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-lg transform overflow-hidden rounded-3xl bg-white md:p-12 p-6 text-center transition-all relative flex flex-col items-center justify-start gap-y-6">
                                    <XIcon
                                        className="w-4 h-4 stroke-current stroke-2 absolute text-textDarkerGray top-6 right-6 cursor-pointer"
                                        onClick={closeModal}
                                    />
                                    <Dialog.Title
                                        as="h1"
                                        className="text-lg text-black90 font-semibold"
                                    >
                                        Servicing Branch Details
                                    </Dialog.Title>
                                    <div className="flex flex-col items-start justify-start md:gap-2 gap-4 max-w-full">
                                        <p className="text-base max-w-full gap-1 truncate font-semibold text-textDarkerGray flex md:flex-row flex-col md:items-center items-start justify-start ">
                                            Branch Name:{' '}
                                            <span className="text-textDarkGray">
                                                {servicingBranch.name}
                                            </span>
                                        </p>
                                        <p className="text-base max-w-full gap-1 truncate font-semibold text-textDarkerGray flex md:flex-row flex-col md:items-center items-start justify-start ">
                                            Address:{' '}
                                            <span className="text-textDarkGray max-w-full truncate">
                                                {servicingBranch.address}
                                            </span>
                                        </p>
                                        <p className="text-base max-w-full gap-1 truncate font-semibold text-textDarkerGray flex md:flex-row flex-col md:items-center items-start justify-start ">
                                            Phone number:{' '}
                                            <a
                                                className="text-links hover:underline"
                                                href={`tel:${servicingBranch.filterPhoneNumber}`}
                                            >
                                                {servicingBranch.phoneNumber}
                                            </a>
                                        </p>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}

ServicingBranchModal.propTypes = {
    servicingBranch: PropTypes.oneOfType([PropTypes.object, PropTypes.any]),
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
}

export default ServicingBranchModal
